import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "../App.min.css";

import Navigation from "../components/navigation/Navigation.js";
import Home from "../components/mainComponents/Home.js";
import About from "../components/mainComponents/About";
import Faq from "../components/mainComponents/FAQ";
import Legal from "../components/mainComponents/Legal";
import Register from "../components/mainComponents/Register";
import SupportDashboard from "../components/mainComponents/SupportComponents/SupportDashboard";
import Process from "../components/mainComponents/process";
import Communicate from "../components/mainComponents/Communicate";
import CreateDelivery from "../components/mainComponents/CreateDelivery";
import PayDeliveryPage from "../components/mainComponents/PayDeliveryPage";
import RegisterCompany from "../components/mainComponents/RegisterCompany";
import RegisterCustomer from "../components/mainComponents/RegisterCustomer";
import QrCode from "../components/mainComponents/QrCode";
import TrackDelivery from "../components/mainComponents/TrackDelivery";
import Refund from "../components/mainComponents/refund";
import DuplicateDelivery from "../components/mainComponents/DuplicateDelivery";

export default function App() {
  return (
    <Router>
      <Navigation />
      <>
        <Routes>
          <Route exact path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/faqs" element={<Faq />} />
          <Route path="/legal" element={<Legal />} />
          <Route path="/privacy" element={<Legal initialPage="privacy" />} />
          <Route path="/register" element={<Register />} />
          <Route exact path="/support" element={<SupportDashboard />} />
          <Route exact path="/support/:mode" element={<SupportDashboard />} />
          <Route
            path="/support/:mode/:ticketId"
            element={<SupportDashboard />}
          />
          <Route path="/process" element={<Process />} />
          <Route path="/communicate" element={<Communicate />} />
          <Route path="/create-delivery" element={<CreateDelivery />} />
          <Route path="/duplicate-delivery" element={<DuplicateDelivery />} />
          <Route path="/pay-delivery" element={<PayDeliveryPage />} />
          <Route path="/register-company" element={<RegisterCompany />} />
          <Route path="/register-customer" element={<RegisterCustomer />} />
          <Route path="/qr-code" element={<QrCode />} />
          <Route path="/track-delivery" element={<TrackDelivery />} />
          <Route path="/refund" element={<Refund />} />
        </Routes>
        <div className="footer-container">
          <div className="container-middle-content footer">
            Copyright © 2025 Trippie Ltd
          </div>
        </div>
      </>
    </Router>
  );
}
